export const abilityGroups = [
  {
    key: 'artist',
    name: 'Artist',
    options: [
      { id: 'barrage', name: 'Barrage', tag: 'Projectiles' },
      { id: 'volatile-anomaly', name: 'Volatile Anomaly', tag: 'Summons' },
      { id: 'shield', name: 'Shield', tag: 'Defense' },
    ],
  },
  {
    key: 'dancer',
    name: 'Dancer',
    options: [
      { id: 'ground-slam', name: 'Ground Slam', tag: 'Aerial' },
      { id: 'push', name: 'Push', tag: 'Control' },
    ],
  },
  {
    key: 'deserter',
    name: 'Deserter',
    options: [
      { id: 'ignite', name: 'Ignite', tag: 'Weapon support' },
      { id: 'inferno', name: 'Inferno', tag: 'Short-range fire' },
    ],
  },
  {
    key: 'collective',
    name: 'Collective',
    options: [
      { id: 'spore-burst', name: 'Spore Burst', tag: 'Projectiles' },
      { id: 'growth', name: 'Growth', tag: 'Summons' },
    ],
  },
  {
    key: 'physicist',
    name: 'Physicist',
    options: [
      { id: 'spike', name: 'Spike', tag: 'Summons' },
      { id: 'astral-rebuke', name: 'Astral Rebuke', tag: 'Control' },
    ],
  },
] as const;
export type GroupKey = (typeof abilityGroups)[number]['key'];
export type BuildState = Partial<Record<GroupKey, string>>;
export const STORAGE_KEY = 'control-resonant-build-v1';
export function sanitizeBuild(value: unknown): BuildState {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  const input = value as Record<string, unknown>;
  const state: BuildState = {};
  for (const group of abilityGroups)
    if (group.options.some((option) => option.id === input[group.key]))
      state[group.key] = input[group.key] as string;
  return state;
}
export function hasBuildParams(value: Record<string, unknown>) {
  return abilityGroups.some((group) => Object.hasOwn(value, group.key));
}
export function buildQuery(state: BuildState) {
  return new URLSearchParams(sanitizeBuild(state)).toString();
}
export function resolveBuild(search: Record<string, unknown>, saved: unknown) {
  return hasBuildParams(search) ? sanitizeBuild(search) : sanitizeBuild(saved);
}
export function buildSummary(state: BuildState) {
  return abilityGroups.flatMap((group) => {
    const option = group.options.find(
      (option) => option.id === state[group.key]
    );
    return option
      ? [{ group: group.name, name: option.name, tag: option.tag }]
      : [];
  });
}
